import { Artifact } from '../store/reducers/sessionReducer'
import { ArtifactItem } from '../types/mentor'
import { decodeArtifact } from '../utils/artifactsUtils'
import apiBase from '../utils/baseApi'
const { VITE_COMPANION_API_BASE_URL } = import.meta.env

const headers = (token: string) => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${token}`,
})

export interface StreamMessage {
  answer: string
  is_chunk: boolean
  is_complete: boolean
  mentor_id: string
  status: string
}

export interface FetchArtifactProps {
  token: string
  mentor_id: string
  artifact_id?: string
  socket_id: string
  onResponseUpdate: (message: StreamMessage) => void
  onAbort?: (controller: AbortController) => void
}

export async function fetchArtifact({
  token,
  mentor_id,
  artifact_id,
  socket_id,
  onResponseUpdate,
  onAbort,
}: FetchArtifactProps) {
  try {
    const abortController = new AbortController()

    if (onAbort) {
      onAbort(abortController) // Allow external control over aborting SSE
    }
    const baseURL = VITE_COMPANION_API_BASE_URL as string

    const response = await fetch(
      `${baseURL}/v2/mentors/${mentor_id}/artifacts${artifact_id ? `/${artifact_id}` : ''}`,
      {
        method: 'POST',
        headers: headers(token),
        body: JSON.stringify({ mentor_id, socket_id }),
        signal: abortController.signal,
      },
    )

    if (!response.ok) {
      throw new Error('Failed to generate persona')
    }

    if (!response.body) {
      throw new Error('No response body')
    } else {
      void decodeArtifact(response, onResponseUpdate)
    }
  } catch (error) {
    console.error('Error sending message:', error)
    throw error
  }
}

interface EditArtifactsProps {
  artifacts: ArtifactItem[]
  mentor_id: string
}

export interface EditArtifactsResponse {
  artifacts: Artifact[]
}
export const editArtifacts = async (
  data: EditArtifactsProps,
): Promise<EditArtifactsResponse> => {
  try {
    const response = await apiBase.post<EditArtifactsResponse>(
      `/v2/admin/mentors/${data.mentor_id}/artifacts`,
      data,
    )

    return response.data
  } catch (error) {
    console.error('Error editing persona:', error)
    throw error
  }
}
